// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;700&family=Roboto:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Changa:wght@500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BASE COLOR
------------------------------------------------------------*/
/* DISPLAY SETTING
------------------------------------------------------------*/
/* OTHER SETTING
------------------------------------------------------------*/
[data-v-7653fc8a]:root {
  font-size: clamp(13px + 2 * (100vw - 1440px) / 480, 1vw, 16px + 2 * (100vw - 1440px) / 480);
  --cx: 0;
  --cy: 0;
  --vw: 100vw;
  --vh: 100vh;
  --screen: 0px;
  --size: 32px;
}
@media screen and (min-width: 1920px) {
[data-v-7653fc8a]:root {
    font-size: 16px;
}
}
@media screen and (max-width: 1023px) {
[data-v-7653fc8a]:root {
    font-size: 14px;
    --size: 16px;
}
}
@media screen and (max-width: 769px) {
[data-v-7653fc8a]:root {
    font-size: 13.5px;
    --size: 10px;
}
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 100;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 200;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 300;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 400;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 500;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Bold");
  font-weight: bold;
}
header[data-v-7653fc8a] {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  padding: 1rem calc(var(--size) + 2vw);
  background: rgba(2, 2, 3, 0.72);
  backdrop-filter: saturate(90%) blur(20px);
  display: grid;
  grid-template-columns: auto auto;
  z-index: 1000;
}
header[data-v-7653fc8a] > * {
  align-self: center;
}
header .logo[data-v-7653fc8a] {
  width: 4rem;
  justify-self: flex-start;
}
header .logo img[data-v-7653fc8a] {
  width: 100%;
}
header nav[data-v-7653fc8a] {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
@media screen and (max-width: 769px) {
header nav[data-v-7653fc8a] {
    display: none;
}
}
header nav ul[data-v-7653fc8a] {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 769px) {
header nav ul[data-v-7653fc8a] {
    display: none;
}
}
header nav ul li[data-v-7653fc8a] {
  line-height: 1;
  margin: 0 0 0 2.4rem;
}
@media screen and (max-width: 1023px) {
header nav ul li[data-v-7653fc8a]:nth-child(1) {
    display: none;
}
header nav ul li[data-v-7653fc8a]:nth-child(2) {
    display: none;
}
header nav ul li[data-v-7653fc8a]:nth-child(3) {
    margin-left: 0;
}
}
header nav ul li[data-v-7653fc8a]:first-child {
  margin-left: 0;
}
header nav ul li a[data-v-7653fc8a] {
  text-transform: uppercase;
  font-size: 1.04rem;
  color: #b8b8ba;
  fill: #e8e8eb;
  display: inline-flex;
  align-items: center;
  position: relative;
  padding: 0.4rem;
  z-index: 1;
}
header nav ul li a[data-v-7653fc8a]:hover {
  color: #f5f5f7;
  fill: #b8b8ba;
}
header nav ul li a svg[data-v-7653fc8a] {
  width: 7.2vmin;
  height: 7.2vmin;
  display: inline-block;
  margin: 0 0 0 0.8vmin;
}
header .contact[data-v-7653fc8a] {
  justify-self: flex-end;
}
header .contact a[data-v-7653fc8a] {
  border: #b8b8ba 1px solid;
  color: #b8b8ba;
  padding: 0.4rem 1.6rem;
  font-size: 0.92rem;
  display: block;
  position: relative;
  z-index: 2;
  transition: all 200ms cubic-bezier(0.65, 0, 0.35, 1);
}
header .contact a[data-v-7653fc8a]:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 100%;
  background: #f5f5f7;
  z-index: -1;
  transition: width 200ms cubic-bezier(0.65, 0, 0.35, 1);
}
header .contact a[data-v-7653fc8a]:hover {
  border-color: #f5f5f7;
  color: #020203;
}
header .contact a[data-v-7653fc8a]:hover:before {
  width: 100%;
  right: auto;
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/scss/module/_module.scss","webpack://./headers.vue","webpack://./src/js/components/headers.vue"],"names":[],"mappings":"AAGA;6DAAA;AAgBA;6DAAA;AAOA;6DAAA;AAEA;EACC,2FAAA;EAKA,OAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACC,aAAA;EACA,YAAA;ACvBF;ADwBC;AAZD;IAaE,eAAA;ACrBA;AACF;ADsBC;AAfD;IAgBE,eAAA;IACE,YAAA;ACnBF;AACF;ADoBC;AAnBD;IAoBE,iBAAA;IACE,YAAA;ACjBF;AACF;AD4GA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACzGD;AD2GA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACzGD;AD2GA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACzGD;AD2GA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACzGD;AD2GA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACzGD;AD2GA;EACC,wBAAA;EACA,4BAAA;EACA,iBAAA;ACzGD;AC9DA;EACE,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,qCAAA;EACA,+BAAA;EACA,yCAAA;EACA,aAAA;EACA,gCAAA;EACA,aAAA;ADgEF;AC/DE;EACE,kBAAA;ADiEJ;AC/DE;EACE,WAAA;EACA,wBAAA;ADiEJ;AChEI;EACE,WAAA;ADkEN;AC/DE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;ADiEJ;AChEI;AALF;IAMI,aAAA;ADmEJ;AACF;AClEI;EFuBH,aAAA;EACA,mBAAA;EACA,8BAHiC;EAIhC,iBAAA;EExBI,mBAAA;EACA,uBAAA;ADuEN;ACtEM;AAJF;IAKI,aAAA;ADyEN;AACF;ACxEM;EACE,cAAA;EACA,oBAAA;AD0ER;ACzEQ;AACE;IACE,aAAA;AD2EV;ACzEQ;IACE,aAAA;AD2EV;ACzEQ;IACE,cAAA;AD2EV;AACF;ACzEQ;EACE,cAAA;AD2EV;ACzEQ;EACE,yBAAA;EACA,kBAAA;EACA,cFjDH;EEkDG,aFnDF;EEoDE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;AD2EV;AC1EU;EACE,cF7DJ;EE8DI,aF1DL;ACsIP;AC1EU;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;AD4EZ;ACtEE;EACE,sBAAA;ADwEJ;ACvEI;EACE,yBAAA;EACA,cF1EC;EE2ED,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,oDAAA;ADyEN;ACxEM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,QAAA;EACA,YAAA;EACA,mBF5FA;EE6FA,WAAA;EACA,sDAAA;AD0ER;ACxEM;EACE,qBFjGA;EEkGA,cFjGA;AC2KR;ACzEQ;EACE,WAAA;EACA,WAAA;EACA,OAAA;AD2EV","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
